import { IS_TRACKING_ENABLED } from '@/common/constants';

/**
 * Safely captures an exception to PostHog via dynamic import.
 * Uses dynamic import to avoid bundling posthog-js into error boundary chunks.
 */
export function captureExceptionToPostHog(error: Error) {
  if (!IS_TRACKING_ENABLED) return;

  import('posthog-js')
    .then(({ default: posthog }) => posthog.captureException(error))
    .catch(() => {});
}
